module.exports = __webpack_public_path__ + "static/Lifestance Health-b3b5ce89ffa1a8aa45f10233a5aba569.jpg";